import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Exercise } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_EXERCISE_BY_ID = 'get-exercise-by-id';

export const useGetExerciseById = (id: number) => {
  return usePermittedQuery<Exercise>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/exercise/${id}`,
    {},
    [GET_EXERCISE_BY_ID, id],
    {
      enabled: typeof id === 'number' && id >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
